import React, { Component } from 'react';
import { Link as RouterLink } from 'react-router-dom';

export default class BreadCrumbs extends Component {

    constructor(props) {
      super(props);
    }

    componentDidMount() {
      console.log('--BreadCrumbs.componentDidMount()');
    }

    generateProgramSummary = (isLast) => {
      if (isLast) {
        return(
          <li key="BreadCrumbs_programSummary">Program Summary</li>     
        );
      } else {
        return(
          <li key="BreadCrumbs_programSummary">
            <RouterLink to='/programsummary' className="breadCrumb">
              Program Summary
            </RouterLink>
          </li>
        );
      }
    }

    generateEducate = (isLast) => {
      if (isLast) {
        return(
          <li key="BreadCrumbs_educate">Educate</li>     
        );
      } else {
        return(
          <li key="BreadCrumbs_educate">
            <RouterLink to='/educate' className="breadCrumb">
              Educate
            </RouterLink>
          </li>
        );
      }
    }

    generateExplore = (isLast) => {
      if (isLast) {
        return(
          <li key="BreadCrumbs_explore">Explore</li>     
        );
      } else {
        return(
          <li key="BreadCrumbs_explore">
            <RouterLink to='/explore' className="breadCrumb">
              Explore
            </RouterLink>
          </li>
        );
      }
    }

    generateVariantDetails = (i, breadCrumb, isLast) => {
      if (isLast) {
        return(
          <li key="BreadCrumbs_variantDetails" >Variant {breadCrumb.variantName}</li>
        );
      } else {
        return(
          <li key="BreadCrumbs_variantDetails">
            <RouterLink 
              to={`/variantdetails/${breadCrumb.variantName}`}
              state={{
                variantId: breadCrumb.variantId,
                variantName: breadCrumb.variantName,
                breadCrumbs: this.props.breadCrumbs.slice(0, i),
              }}
              className="breadCrumb"
            >
            Variant {breadCrumb.variantName}
            </RouterLink>
          </li>
        );
      }
    }

    generatePatientDetails = (i, breadCrumb, isLast) => {
      if (isLast) {
        return(
          <li key="BreadCrumbs_patientDetails">Patient {breadCrumb.patientId}</li>
        );
        } else {
        return(
            <li key="BreadCrumbs_patientDetails">
            <RouterLink 
              to={`/patientdetails/${breadCrumb.patientId}`}
              state={{
                patientId: breadCrumb.patientId,
                programId: breadCrumb.programId,
                potentialConditionsString: breadCrumb.potentialConditionsString,
                breadCrumbs: this.props.breadCrumbs.slice(0, i),
              }}
              className="breadCrumb"
            >
            Patient {breadCrumb.patientId}
            </RouterLink>
            </li>
        );
      }
    }

    generateAddInterpretation = () => {
      return(
        <li key="BreadCrumbs_addInterpretation">Add Interpretation</li>
      );
    }

    generateVariantConsensus = () => {
      return(
        <li key="BreadCrumbs_variantConsensus">Variant Consensus</li>
      );
    }

    generateUserDashboard = () => {
      return(
        <li key="BreadCrumbs_userDashboard">User Dashboard</li>
      );
    }

    generateUserManagement = (isLast) => {
      if (isLast) {
        return(
          <li key="BreadCrumbs_userManagement">User Management</li>
        );
      } else {
        return(
          <li key="BreadCrumbs_userManagement">
            <RouterLink 
              to='/usermanagement'
              className="breadCrumb"
            >
              User Management
            </RouterLink>
          </li>
        );
      }
    }

    generateProgramDashboard = (isLast) => {
      if (isLast) {
        return(
          <li key="BreadCrumbs_programDashboard">Program Dashboard</li>     
        );
      } else {
        return(
          <li key="BreadCrumbs_programDashboard">
            <RouterLink 
              to='/programdashboard'
              className="breadCrumb"
            >
              Program Dashboard
            </RouterLink>
          </li>
        );
      }
    }

    generateVariantDashboard = (breadCrumb) => {
      return(
        <li key="BreadCrumbs_variantDashboard">Variant Dashboard: {breadCrumb.variantName}</li>
      );
    }

    generateProgramSettings = (isLast) => {
      if (isLast) {
        return(
          <li key="BreadCrumbs_programSettings">Program Settings</li>
        );
      } else {
        return(
          <li key="BreadCrumbs_programSettings">
            <RouterLink 
              to='/programsettings'
              className="breadCrumb"
            >
              Program Settings
            </RouterLink>
          </li>
        );
      }
    }

    generateWorkflowRuns = () => {
      return(
        <li key="BreadCrumbs_workflowruns">Workflow Runs</li>
      );
    }

    generateVariantAnnotationData = () => {
      return(
        <li key="BreadCrumbs_variantAnnotationData">Variant Annotation Data</li>
      );
    }

    render() {
      let output = [];
      for (const [i, breadCrumb] of this.props.breadCrumbs.entries()) {                                                         
        switch(breadCrumb.name) {
          case 'ProgramSummary':
            if (i === (this.props.breadCrumbs.length - 1)) {
              output.push(this.generateProgramSummary(true));
            } else {
              output.push(this.generateProgramSummary(false));
            }
            break;
          case 'Educate':
            if (i === (this.props.breadCrumbs.length - 1)) {
              output.push(this.generateEducate(true));
            } else {
              output.push(this.generateEducate(false));
            }
            break;
          case 'Explore':
            if (i === (this.props.breadCrumbs.length - 1)) {
              output.push(this.generateExplore(true));
            } else {
              output.push(this.generateExplore(false));
            }
            break;
          case 'VariantDetails':
            if (i === (this.props.breadCrumbs.length - 1)) {
              output.push(this.generateVariantDetails(i, breadCrumb, true));
            } else {
              output.push(this.generateVariantDetails(i, breadCrumb, false));
            }
            break;
          case 'PatientDetails':
            if (i === (this.props.breadCrumbs.length - 1)) {
              output.push(this.generatePatientDetails(i, breadCrumb, true));
            } else {
              output.push(this.generatePatientDetails(i, breadCrumb, false));
            }
            break;
          case 'AddInterpretation':
            output.push(this.generateAddInterpretation());
            break;
          case 'VariantConsensus':
            output.push(this.generateVariantConsensus());
            break;
          case 'UserDashboard':
            output.push(this.generateUserDashboard());
            break;
          case 'UserManagement':
            if (i === (this.props.breadCrumbs.length - 1)) {
              output.push(this.generateUserManagement(true));
            } else {
              output.push(this.generateUserManagement(false));
            }
            break;
          case 'ProgramDashboard':
            if (i === (this.props.breadCrumbs.length - 1)) {
              output.push(this.generateProgramDashboard(true));
            } else {
              output.push(this.generateProgramDashboard(false));
            }
            break;
          case 'VariantDashboard':
            output.push(this.generateVariantDashboard(breadCrumb));
            break;
          case 'ProgramSettings':
            if (i === (this.props.breadCrumbs.length - 1)) {
              output.push(this.generateProgramSettings(true));
            } else {
              output.push(this.generateProgramSettings(false));
            }
            break;
          case 'WorkflowRuns':
            output.push(this.generateWorkflowRuns());
            break;
          case 'VariantAnnotationData':
            output.push(this.generateVariantAnnotationData());
            break;
        }
      }

      return (
        <div>
          <ul className="breadCrumbs" >
            <li key="BreadCrumbs_baseUrl">
              <RouterLink 
                to='/home'
                className="breadCrumb"
              >
                ED3N
              </RouterLink>
            </li>
            {output}
          </ul>
        </div>
      );
    }

}